module.exports = __webpack_public_path__ + "static/img/banner04.ff94b0e2.png";